import { useBodyLock } from '#src/common/hooks/useBodyLock'

export const BodyLock = ({ children = null }) => {
  useBodyLock(true)
  return children
}
